/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:14:53
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-02-28 17:12:31
 * @FilePath: \newsmartmapout\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'leaflet/dist/leaflet.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import VueScroll from '@david-j/vue-j-scroll';
Vue.use(VueScroll);
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.directive('drag', function (el) {
  const oDiv = el // 当前元素
  document.onselectstart = () => {
    return false
  }
  oDiv.onmousedown = e => { // 鼠标按下时的鼠标所在的X，Y坐标
    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - oDiv.offsetLeft
    const disY = e.clientY - oDiv.offsetTop
    document.onmousemove = e => {
      // 通过事件委托，计算移动的距离
      // 因为浏览器里并不能直接取到并且使用clientX、clientY,所以使用事件委托在内部做完赋值
      const l = e.clientX - disX
      const t = e.clientY - disY
      // 计算移动当前元素的位置，并且给该元素样式中的left和top值赋值
      oDiv.style.left = l + 'px'
      oDiv.style.top = t + 'px'
    }
    document.onmouseup = e => { // 鼠标抬起，清空之前所在的位置，新拖拽的位置已生成并赋值
      document.onmousemove = null
      document.onmouseup = null
    }
    // return false不加的话可能导致黏连，拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
    return false
  }
}
)


Vue.prototype.$axios = axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
